export const FETCH_SITE_SUCCESS = 'FETCH_SITE_SUCCESS';
export const DUMMY_ACTION_M = 'DUMMY_ACTION_M';
